import { ModelAdvertParametersInterface } from './types'

export const getModelAdvertAliasURLPart = ({ advertiserAlias, model }: ModelAdvertParametersInterface) => `${advertiserAlias}/${model}`

export const getModelAdvertAliasRESTApiParameter = ({ advertiserAlias, model }: ModelAdvertParametersInterface) => `${advertiserAlias}_${model}`
